import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";
import React from 'react';

export default function CancelButton({ text, onPress, flex }) {
    return (
        <Button variant='outline' onPress={onPress} className={` flex-${flex} px-2 w-[100%] bg-secondary-50 border-primary-900 active:bg-secondary-200 `}>
            <Text className="font-[400] text-lg text-primary-900">{text}</Text>
        </Button>
    );
}